import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  FormFieldBase,
  FormFieldType
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import {
  FormFieldControlService
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/services/dynamic-form-field-control.service";
import {ProtocolFascicoloDialogComponent} from "../dialog/protocol-fascicolo-dialog.component";
import {DialogService} from "../../../../../core/components/dialog/dialog.service";
import {ProtocolService} from "../../../services/protocol.service";
import {ModalNotifyService} from "../../../../../core/services/modal-notify.service";
import {filter, takeUntil, tap} from "rxjs/operators";
import {ConfigurationService} from 'src/app/common/configuration/services/configuration.service';
import {ConfigurationFeature} from 'src/app/common/configuration/models/configuration';
import {ProtocolMetadata} from '../../../models/protocol';
import {Subject} from 'rxjs';
import {
  ConfirmModalComponent
} from "../../../../../core/components/dialog/components/confirm-modal/confirm-modal.component";
import {ProtocolStore} from "../../../stores/protocol-store";
import { UtenteLoggato } from 'src/app/common/models/utente-loggato';
import { UserManager } from 'src/app/core/services/user-manager';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { ActivatedRoute } from '@angular/router';
declare var closeModal: any;
declare var openModal: any;
export namespace ProtocolFascicoloFormFields {
  export const DOSSIER_NUMBER: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-dossier-number",
    label: "N° fascicolo",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4"
  }
  export const UTENTE_PROTOCOLLATORE: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-protocol-user",
    label: "Utente protocollatore",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4"
  }

  export const PROTOCOL_NUMBER: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-protocol-number",
    label: "Numero protocollo",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4"
  }

  export const REGISTRATION: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-registration",
    label: "Registrazione",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4",
  }

  export const SENDER_RECEIVER: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-mittente-destinatario",
    label: "Mittente/Destinatario",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4",
    tooltip: 'NA'
  }

  export const DATE_PROTOCOL: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-date-protocol",
    label: "Data protocollo",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-4"
  }

  export const SUBJECT: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "pff-subject",
    label: "Oggetto",
    placeholder: "NA",
    chips: false,
    disabled: true,
    size:"col-sm-12",
    tooltip: 'NA'
  }

}

@Component({
  selector: 'app-protocol-fascicolo-form',
  templateUrl: './protocol-fascicolo-form.component.html',
  styleUrls: ['./protocol-fascicolo-form.component.css']
})
export class ProtocolFascicoloFormComponent implements OnInit {

  @Input() dataView: ProtocolMetadata;
  @Input() fascicolo: FascicoloFull;
  @Input() showNumeroFascicolo = false;
  @Input() showNumeroProtocol = true;
  @Input() showDataProtocol = true;
  @Input() showUserProtocol = true;
  @Input() showOggetto = true;
  @Input() showsenderReceiver = true;
  @Input() showRegistration = true;
  @Input() showCerca = true;
  @Input() isSearch: boolean = false;
  @Output() protocolDataChange = new EventEmitter<ProtocolMetadata>();
  form: FormGroup;
  isProtocolNumber:boolean = false;
  protected formFields: FormFieldBase[];
  protected isConfigurationEnabled: boolean = false;
  private componentDestroyed$: Subject<void> = new Subject<void>();
  private utenteLoggato: UtenteLoggato;
  private search: boolean = false;

  constructor(
    private formFieldControlService: FormFieldControlService,
    private protocolService: ProtocolService,
    private dialog: DialogService,
    private notify: ModalNotifyService,
    private configService: ConfigurationService,
    private userManager: UserManager,
    private route: ActivatedRoute,
  ) {}

  public ngOnInit() {
    console.log("[ngOnInit]");
    this.isConfigurationEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.PROTOCOL);
    this.utenteLoggato= this.userManager.getUser();
    console.log('utenteLoggato',this.utenteLoggato)
    this.initForm();
  }

  protected initForm() {
    if (this.isConfigurationEnabled) {
    console.log("[initForm]");
    this.formFields = [];

    if (this.showNumeroFascicolo) {
      this.formFields.push(ProtocolFascicoloFormFields.DOSSIER_NUMBER);
    }
    if (this.showNumeroProtocol) {
      this.formFields.push(ProtocolFascicoloFormFields.PROTOCOL_NUMBER);
    }
    if (this.showDataProtocol) {
      this.formFields.push(ProtocolFascicoloFormFields.DATE_PROTOCOL);
    }
    if (this.showUserProtocol) {
      this.formFields.push(ProtocolFascicoloFormFields.UTENTE_PROTOCOLLATORE);
    }
    if (this.showsenderReceiver) {
      this.formFields.push(ProtocolFascicoloFormFields.SENDER_RECEIVER);
    }
    if (this.showRegistration) {
      this.formFields.push(ProtocolFascicoloFormFields.REGISTRATION);
    }
    if (this.showOggetto) {
      this.formFields.push(ProtocolFascicoloFormFields.SUBJECT);
    }

    this.form = this.formFieldControlService.toFormGroup(this.formFields, this.form);
    ProtocolFascicoloFormFields.SUBJECT.tooltip = '';
    ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = '';
      if (this.dataView) {
        console.log("Data View: ", this.dataView); // Log del dataView
        this.form.controls[ProtocolFascicoloFormFields.DOSSIER_NUMBER.key]?.setValue(this.dataView.dossierNumber ?? 'N/A');
        this.form.controls[ProtocolFascicoloFormFields.PROTOCOL_NUMBER.key]?.setValue(this.dataView.protocolNumber);
        this.form.controls[ProtocolFascicoloFormFields.DATE_PROTOCOL.key]?.setValue(this.dataView.protocolTimestamp);
        this.form.controls[ProtocolFascicoloFormFields.UTENTE_PROTOCOLLATORE.key]?.setValue(this.dataView.protocolUser);
        this.form.controls[ProtocolFascicoloFormFields.SUBJECT.key]?.setValue(this.dataView.subject);
        this.form.controls[ProtocolFascicoloFormFields.REGISTRATION.key]?.setValue(this.dataView.tipoReg);
        ProtocolFascicoloFormFields.SUBJECT.tooltip = this.dataView.subject.length > 60 ? this.dataView.subject : '';
        this.form.controls[ProtocolFascicoloFormFields.SENDER_RECEIVER.key]?.setValue(this.dataView.senderReceiver);
        ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = this.dataView.senderReceiver.length > 30 ? this.dataView.senderReceiver : '';
      }
    }
  }

  convertDate(milliseconds:number):string{
   return new Date(milliseconds).toLocaleString('it-IT',{ year: 'numeric', month:'2-digit', day: '2-digit', hour: '2-digit', minute:'2-digit'})
  }

  convertDateToMillis(data:string):number{
    return new Date(data).getMilliseconds();
   }

  protected onFormFieldEvent(event) {
    console.log("[onFormChangeValue]", event);
  }

  protected onSearchButton(event) {
    if (this.isConfigurationEnabled) {
      if(document.getElementById("modalmodDatiGenerali")) {
        closeModal("modalmodDatiGenerali")
       }
    const ref = this.dialog.open(ProtocolFascicoloDialogComponent, {
      data: {
        title: "Ricerca dati Protocollo",
        fascicolo: this.fascicolo,
        idPratica: this.fascicolo?.praticaBase?.id || this.route.snapshot.paramMap.get('idPratica'),
        style: {
          width: '100%'
        },
      }
    });
    ref.afterClosed
      .pipe(
        tap(
          it => console.log(it)
        ),takeUntil(this.componentDestroyed$),
        filter(it =>it)
      ).subscribe((it: {action: "IMPORT" | "INSERT", response: any, closeEvent?: boolean}) => {
        if(it.closeEvent) {
          if(document.getElementById("modalmodDatiGenerali")) {
          openModal("modalmodDatiGenerali")
         }
          return
        };
        if(it.action === "IMPORT") {
          this.onSearchComplete(it.response.metadata);
          if (it.response.metadata.protocolNumber) {
            this.isProtocolNumber = true;
          }
        } else if(it.action === "INSERT") {
          if(this.fascicolo?.id){
            this.protocolService.protocolDocument(it.response,this.fascicolo.id).subscribe(
              res => {
                if (res) {
                  res.metadata.protocolDocuments = it.response.documentProtocol; 
                  this.onInsertComplete(res.metadata);
                  if (res.metadata.protocolNumber) {
                    this.isProtocolNumber = true;
                  }
                }
              }
            )
          }
          else{
            this.protocolService.postFascicolo(it.response).subscribe( 
              res => {
                if (res) {
                  res.metadata.protocolDocuments = it.response.documentProtocol; 
                  this.onInsertComplete(res.metadata);
                  if (res.metadata.protocolNumber) {
                    this.isProtocolNumber = true;
                  }
                }
              }
            )
          }            
        }
    });
    }
  }

  protected onCleanButton() {
    console.log("[onCleanButton]");
    this.notify.genericMessageWithConfirm('Attenzione','Confermi di voler eliminare i dati della protocollazione? Ricorda che i documenti associati dovranno essere cancellati manualmente.')
    .subscribe((confirmed: boolean) => {
      if (confirmed) {
        // Procedi con la pulizia dei campi se l'utente conferma
        this.cleanFields();
      }
    });
  }

  cleanFields(): void {
    this.form.reset();
    this.protocolDataChange.emit(null);
    ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = '';
    ProtocolFascicoloFormFields.SUBJECT.tooltip = '';
    if (this.dataView) {
      this.dataView = null;
    }
    this.isProtocolNumber = false;
  }



  private onSearchComplete(metadata: ProtocolMetadata) {
    this.search = true;
    if (this.showNumeroFascicolo) {
      this.form.controls[ProtocolFascicoloFormFields.DOSSIER_NUMBER.key].setValue(metadata.dossierNumber);
    }
    if (this.showNumeroProtocol) {
      metadata.protocolNumber = metadata.sigla+'/'+metadata.protocolYear+'/'+metadata.protocolNumber;
      this.form.controls[ProtocolFascicoloFormFields.PROTOCOL_NUMBER.key].setValue(metadata.protocolNumber);
    }
    if (this.showDataProtocol) {
      this.form.controls[ProtocolFascicoloFormFields.DATE_PROTOCOL.key].setValue(metadata.protocolTimestamp);
    }
    if (this.showRegistration) {
      this.form.controls[ProtocolFascicoloFormFields.REGISTRATION.key]?.setValue(metadata.tipoReg);
    }
    if (this.showUserProtocol) {
      metadata.protocolUser = (this.search ? 'N/A': (this.utenteLoggato?.nome+' '+this.utenteLoggato?.cognome));
      this.form.controls[ProtocolFascicoloFormFields.UTENTE_PROTOCOLLATORE.key].setValue(metadata.protocolUser);
    }
    if (this.showsenderReceiver) {
      this.form.controls[ProtocolFascicoloFormFields.SENDER_RECEIVER.key].setValue(metadata.senderReceiver);
      ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = metadata.senderReceiver.length > 30 ? metadata.senderReceiver : '';
    }
    if (this.showOggetto) {
      this.form.controls[ProtocolFascicoloFormFields.SUBJECT.key].setValue(metadata.subject);
      ProtocolFascicoloFormFields.SUBJECT.tooltip =  metadata.subject.length > 60 ? metadata.subject : '';
    }
    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: "Ricerca Protocollo",
        style: {
          width: '60%'
        },
        modalConfirm: {
          text: "Associazione protocollo avvenuta con successo",
          hideButtons: true,
          confirmButton: true
        }
      }
    });
    ProtocolStore.cleanSearchCache();
    this.protocolDataChange.emit(metadata);
    if(document.getElementById("modalmodDatiGenerali")) {
      openModal("modalmodDatiGenerali")
    }

  }

  private onInsertComplete(metadata: ProtocolMetadata) {
    console.log(metadata, 'metadata')
    this.search = false;
    if (this.showNumeroFascicolo) {
      this.form.controls[ProtocolFascicoloFormFields.DOSSIER_NUMBER.key].setValue(metadata.dossierNumber);
    }
    if (this.showNumeroProtocol) {
      metadata.protocolNumber = metadata.sigla+'/'+metadata.protocolYear+'/'+metadata.protocolNumber;
      this.form.controls[ProtocolFascicoloFormFields.PROTOCOL_NUMBER.key].setValue(metadata.protocolNumber);
    }
    if (this.showDataProtocol) {
      this.form.controls[ProtocolFascicoloFormFields.DATE_PROTOCOL.key].setValue(metadata.protocolTimestamp);
    }

    if (this.showRegistration) {
      this.form.controls[ProtocolFascicoloFormFields.REGISTRATION.key]?.setValue(metadata.tipoReg);
    }

    if (this.showUserProtocol) {
      metadata.protocolUser = (this.search ? 'N/A': (this.utenteLoggato?.nome+' '+this.utenteLoggato?.cognome));
      this.form.controls[ProtocolFascicoloFormFields.UTENTE_PROTOCOLLATORE.key].setValue(metadata.protocolUser);
    }
    if (this.showOggetto) {
      this.form.controls[ProtocolFascicoloFormFields.SUBJECT.key].setValue(metadata.subject);
      ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = metadata.subject.length > 60 ? metadata.subject : '';
    }
    if (this.showsenderReceiver) {
      this.form.controls[ProtocolFascicoloFormFields.SENDER_RECEIVER.key].setValue(metadata.senderReceiver);
      ProtocolFascicoloFormFields.SENDER_RECEIVER.tooltip = metadata.senderReceiver.length > 30 ? metadata.senderReceiver : '';
    }
    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: "Inserimento Protocollo",
        style: {
          width: '60%',
        },
        modalConfirm: {
          text: "Registrazione avvenuta con successo.",
          hideButtons: true,
          confirmButton: true
        }
      }
    });
    ProtocolStore.cleanInsertCache();
    this.protocolDataChange.emit(metadata);
    if(document.getElementById("modalmodDatiGenerali")) {
      openModal("modalmodDatiGenerali")
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

}
